import React from "react";
import { Seo } from "./Seo";
import Hero from "./Homepage/Hero";
import Services from "./Homepage/Services";
import WhyUs from "./Homepage/WhyUs";
import Process from "./Homepage/Process";
import Testimonials from "./Homepage/Testimonials";
import Areas from "./Homepage/Areas";
import SectionHeading from "./UI/SectionHeading";
import Faq, { faqSchema } from "./UI/Faq";
import CtaBand from "./UI/CtaBand";

const homeFaqs = [
  {
    q: "What areas do you cover?",
    a: "We’re based in Cambridge and cover the city and surrounding villages including Cherry Hinton, Trumpington, Girton, Histon, Great Shelford, Sawston, Cambourne, Ely and Newmarket. If you’re a little further out, get in touch and we’ll let you know.",
  },
  {
    q: "Do you offer free quotes?",
    a: "Yes. We visit, take measurements, discuss your ideas and follow up with a clear written quote, all free and with no obligation.",
  },
  {
    q: "Are you insured?",
    a: "We’re fully insured and take care to keep your home clean and protected while we work, tidying up at the end of every day.",
  },
  {
    q: "Do you take on small jobs as well as big projects?",
    a: "Absolutely. From hanging a single door or building one alcove unit to fitting a whole kitchen or a run of wardrobes, no job is too small.",
  },
  {
    q: "How do I get started?",
    a: "Give us a call on 07798 525115 or send a message through our contact page with a few details about your project, and we’ll arrange a convenient time to visit.",
  },
];

export default function HomePage() {
  const websiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "Cambridge Carpenter",
    url: "https://www.cambridgecarpenter.co.uk/",
  };

  return (
    <>
      <Seo
        title="Carpenter in Cambridge | Bespoke Carpentry & Joinery | Cambridge Carpenter"
        description="Cambridge Carpenter builds fitted furniture, kitchens, decking, loft conversions and bespoke joinery across Cambridge and Cambridgeshire. Free consultations and quotes."
        canonical="https://www.cambridgecarpenter.co.uk/"
        schema={[websiteSchema, faqSchema(homeFaqs)]}
      />
      <Hero />
      <Services />
      <WhyUs />
      <Process />
      <Testimonials />
      <Areas />

      <section className="bg-linen border-t border-hairline">
        <div className="max-w-site mx-auto px-5 sm:px-10 py-16 md:py-24">
          <div className="lg:grid lg:grid-cols-[1fr_1.6fr] lg:gap-16 items-start">
            <div className="mb-8 lg:mb-0">
              <SectionHeading eyebrow="Questions" title="Frequently asked questions" />
            </div>
            <Faq items={homeFaqs} />
          </div>
        </div>
      </section>

      <CtaBand />
    </>
  );
}
